import lodash from 'lodash';
import { action } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';
export class RapidQuotationDetailsController extends BasesController<any> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.rapidQuotation_details,
      insert: EnumAPI.business_saveProduct,
      update: EnumAPI.business_updateProduct,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        response: {
          valueGetter: (response) => this.valueGetter(response),
        },
      },
    });
  }
  @action.bound
  onSetState(name, value) {
    this[name] = value;
  }
  private valueGetter(response) {
    // this.onSetState('isIncludeSign', lodash.get(response, 'isIncludeSign'));
    return {
      dataSource: lodash.get(response, 'records'),
    };
  }
  /**
   * @des 根据id获取产品信息详情
   */
  async onGetDetail(body) {
    return await AjaxBasics.request({
      ...EnumAPI.rapidQuotation_details,
      body,
    });
  }
}
